import React from "react";
import { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next/hooks";
import Img from "react-cool-img";

import Button from "../../Button/Button";
// import GroupInfoMemberItem from "./GroupInfoMemberItem";
import GroupInfoModal from "./GroupInfoModal";
import Loader from '../../Loader/Loader';

import { useStore } from "../../../hook-store/store";
import { getLocalTimeElements } from "../../../util/timeFormat";
import { getUserDescription, getUserImageUrl } from "../../../util/user";

import SampleImage from "../../Image/person-icon-50.jpg";


import classes from './GroupInfoMemberList.module.css'

import { GQL_URL, BASE_URL } from "../../../App";

const GroupInfoMemberItem = (props) => {
  const { 
    member,
    selectedUserId,
    userDescription,
  } = props;
  // console.log("GroupInfoMemberList-props", props);

  const [t] = useTranslation("translation");

  const [store, dispatch] = useStore();
  const {
    userData,
  } = store;
  const { 
    socketState,
    selectedGroupData,
    groupRoomInUsersData,
    isGroupMember,
  } = store.groupStore;
  // console.log('store in GroupInfoMemberList', store);


  let nameData;
  let isRoomIn = false;

  const userInfo2 = selectedGroupData?.allMemberUserIds.find((element) => {
    return element.userId === member.userId;
  });

  const joinDate = getLocalTimeElements(userInfo2.addAt).dateDisplay;
  const lsNameDataList = localStorage.getItem('lsNameDataList');


  if (lsNameDataList && JSON.parse(lsNameDataList).length > 0) {
    nameData = JSON.parse(lsNameDataList).find(ele => {
      return ele.userId === member.userId;
    });
  }

  const roomInUsers = groupRoomInUsersData?.groupRoomInUsers;

  if (roomInUsers && roomInUsers.length > 0) {
    // console.log('roomInUsers', roomInUsers)
    isRoomIn = roomInUsers.find(element => {
      return element.userId === member.userId;
    });
  }


  let groupInfoMemberItemBody;

  groupInfoMemberItemBody = (
    <div>
      <div className="groupTalkTextList-allMemberElement">
        <div className="groupTalkTextList-memberListElement">
          {/* {member.name} */}
          {localStorage.getItem('userId') && nameData && (
            <span> 
              {nameData.name}
            </span>
          )}
        </div>
        <div className="groupTalkTextList-memberListElement">
          {/* <Img
            className={classes.grupInfoMemberListImage}
            src={userImageUrl ? userImageUrl : SampleImage}
            // height="25"
            alt="user-img"
          /> */}
          {localStorage.getItem('userId') && nameData?.imageUrl && (
            <Img className={classes.grupInfoMemberListImage}
              // style={{height: "1rem", width: "1rem", objectFit: "cover"}}
              src={nameData.imageUrl} 
            />
          )}
          {localStorage.getItem('userId') && !nameData?.imageUrl && (
            <Img className={classes.grupInfoMemberListImage}
              // style={{height: "1rem", width: "1rem", objectFit: "cover"}}
              src={SampleImage} 
            />
          )}

        </div>
        {isRoomIn && (
          <div className="groupTalkTextList-memberListElement"
            style={{color: "lightgreen", fontSize: "2rem"}}
          >
            &middot;
          </div>
        )}

      </div>
      {/* <div className="groupTalkTextList-memberListElement">
        {isOnline ? " (online)" : ""}
      </div> */}

      {/* <div>&#9662;</div> */}


    {selectedUserId && selectedUserId === member.userId && (
      <div className="groupTalkTextList-descriptionContainer">
        {userDescription}

        {/* <div>user-created-at: {userCreateDate}</div> */}
        <div className="groupTalkTextList-descriptionDate">
          group join date: {joinDate}
        </div>

        {props.isAuth && member.userId !== props.userId && nameData?.name && (
          <div></div>
        )}
      </div>
    )}
  </div>
);

  return (
    <Fragment>
      {groupInfoMemberItemBody}
    </Fragment>
  );
};

export default GroupInfoMemberItem;
